var _defs, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAddXl(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".e{fill:#071d49;fill-rule:evenodd;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "b"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    id: "d",
    className: "e",
    d: "M47.8,8.2C42.55,2.95,35.43,0,28,0S13.45,2.95,8.2,8.2C2.95,13.45,0,20.57,0,28s2.95,14.55,8.2,19.8c5.25,5.25,12.37,8.2,19.8,8.2s14.55-2.95,19.8-8.2c5.25-5.25,8.2-12.37,8.2-19.8s-2.95-14.55-8.2-19.8Zm-24.75,4.35c1.31-1.31,3.09-2.05,4.95-2.05s3.64,.74,4.95,2.05,2.05,3.09,2.05,4.95-.74,3.64-2.05,4.95c-1.31,1.31-3.09,2.05-4.95,2.05s-3.64-.74-4.95-2.05c-1.31-1.31-2.05-3.09-2.05-4.95s.74-3.64,2.05-4.95Zm13.7,34.54c-2.75,1.26-5.73,1.91-8.75,1.91-3.02,0-6.01-.65-8.75-1.91-2.75-1.26-5.19-3.1-7.16-5.39,1.4-3.05,3.64-5.63,6.46-7.44,2.82-1.81,6.1-2.77,9.45-2.77,3.35,0,6.63,.96,9.45,2.77,2.82,1.81,5.06,4.39,6.46,7.44-1.97,2.29-4.41,4.13-7.16,5.39Zm13.76-20.52h-4.5v4.5c0,.83-.67,1.5-1.5,1.5s-1.5-.67-1.5-1.5v-4.5h-4.5c-.83,0-1.5-.67-1.5-1.5s.67-1.5,1.5-1.5h4.5v-4.5c0-.83,.67-1.5,1.5-1.5s1.5,.67,1.5,1.5v4.5h4.5c.83,0,1.5,.67,1.5,1.5s-.67,1.5-1.5,1.5Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddXl);
export default __webpack_public_path__ + "static/media/ADD_XL.b3c219c794eee44a8e0dbb2c9fa8a31c.svg";
export { ForwardRef as ReactComponent };